<div class="status">
  <img class="status-image" src="assets/images/cross.svg" alt="status" />
  <div class="status-description">{{ this.statusDescription }}</div>
</div>
